module.exports = __webpack_public_path__ + "static/media/alimentos5.fcee9c1c.png";